import { api } from 'common';

import { ConversationBlockFormFields } from './FormFields';
import { ConversationBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

const defaultTimeout = { value: '30', units: api.FlowDefinition.DurationUnits.Days };

export const conversationNodeConfig: BlockConfigProps<
  api.FlowDefinition.ConversationBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'Conversation',
  defaultConfig: {
    callerPhoneNumberId: null,
    firstMessage: 'Hello, this is an automated message from your healthcare provider.',
    tags: [],
    timeout: defaultTimeout,
    patientReplyHandler: undefined,
    mode: api.FlowDefinition.ConversationBlockMode.Create,
  },
  configFields: {
    schema: api.FlowDefinition.ConversationBlockConfigSchema,
    FormFields: ConversationBlockFormFields,
  },
  documentationMarkdown: ConversationBlockDocumentationMarkdown,
};
